export const initialValuesEditQuotePartner = {
	status : "",
	signedAt :"",
	profit :"",
	total:"",
}
